export function featureFlagEnabled(value) {
  return /^(1|true|yes|on)$/i.test(String(value || "").trim());
}

export const paymentsEnabled = featureFlagEnabled(
  process.env.REACT_APP_PAYMENTS_ENABLED
);

export const enamadEnabled = featureFlagEnabled(
  process.env.REACT_APP_ENAMAD_ENABLED
);

// Payment provider configured for this server: "stripe" or "zarinpal".
export const paymentProvider = String(
  process.env.REACT_APP_PAYMENT_PROVIDER || "stripe"
).trim().toLowerCase();

// Zarinpal has no recurring payments: users renew manually and checkout asks
// for a mobile number (for renewal reminders) and an optional discount code.
export const manualRenewal = paymentProvider === "zarinpal";

// Mobile numbers are Iranian-only, so phone signup and login exist on Zarinpal
// servers alone. Mirrors PHONE_NUMBERS_ENABLED in the backend settings.
export const phoneNumbersEnabled = paymentProvider === "zarinpal";
